
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 485 485","fill":"#fff"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M413.974 71.026C368.171 25.225 307.274 0 242.5 0S116.829 25.225 71.026 71.026C25.225 116.829 0 177.726 0 242.5s25.225 125.671 71.026 171.474C116.829 459.775 177.726 485 242.5 485c32.731 0 64.491-6.414 94.397-19.063l-11.688-27.63C299.022 449.384 271.194 455 242.5 455 125.327 455 30 359.673 30 242.5S125.327 30 242.5 30 455 125.327 455 242.5c0 51.323-31.534 74.699-60.834 74.699-29.299 0-60.833-23.375-60.833-74.699 0-50.086-40.747-90.833-90.833-90.833s-90.833 40.748-90.833 90.833 40.747 90.833 90.833 90.833c29.655 0 56.034-14.286 72.622-36.335 4.248 8.577 9.594 16.336 16.04 23.113 16.613 17.468 38.988 27.087 63.004 27.087 24.017 0 46.392-9.62 63.005-27.087C475.377 300.97 485 274.132 485 242.5c0-64.774-25.225-125.671-71.026-171.474zM242.5 303.333c-33.543 0-60.833-27.29-60.833-60.833s27.29-60.833 60.833-60.833 60.833 27.29 60.833 60.833-27.29 60.833-60.833 60.833z"}})])
          )
        }
      }
    